"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warn = warn;
exports.toDashesCase = toDashesCase;
exports.isElement = isElement;
exports.isNode = isNode;
exports.filterStringArgs = filterStringArgs;
exports.optimizeTarget = optimizeTarget;
exports.preventDefault = preventDefault;
exports.sleep = sleep;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _variables = _interopRequireDefault(require("../variables"));

var _is_js = _interopRequireDefault(require("is_js"));

function warn(message, locationName) {
  if (_variables["default"].debugLogs) {
    console.warn(message + ". Warning source - ".concat(locationName));
  } else {
    if (_variables["default"].debugLogsDisabledNotify) {
      console.info('%cDebug mode is disabled. You will not see any error messages from "$helpers"', 'color: orange;');
    }
  }
}

function toDashesCase(string) {
  return string.replace(/[A-Z]/g, function (m) {
    return '-' + m.toLowerCase();
  });
}

function isElement(target) {
  return (typeof HTMLElement === "undefined" ? "undefined" : (0, _typeof2["default"])(HTMLElement)) === 'object' ? target instanceof HTMLElement : target && (0, _typeof2["default"])(target) === 'object' && target !== null && target.nodeType === 1 && typeof target.nodeName === 'string';
}

function isNode(target) {
  return (typeof Node === "undefined" ? "undefined" : (0, _typeof2["default"])(Node)) === "object" ? target instanceof Node : target && (0, _typeof2["default"])(target) === "object" && typeof target.nodeType === "number" && typeof target.nodeName === "string";
}

function filterStringArgs(targets) {
  return targets.toString().split(/[\s,]+/).filter(function (e) {
    return e.length;
  });
}

function optimizeTarget(target) {
  return _is_js["default"].not.array(target) && !isElement(target) && target !== window ? document.querySelector(target) : target;
}

function preventDefault(event) {
  (event.originalEvent || event).preventDefault();
  return event;
}

function sleep(ms) {
  var tm = null;
  return new Promise(function (resolve) {
    tm = setTimeout(resolve, ms);
  }).then(function () {
    clearTimeout(tm);
    tm = null;
  });
}